import { environment } from "src/environments/environment";

export var apiInsightURL = environment.apiBaseURLInsight + "/api/rest/server";
export var apiLoginURL = environment.apiBaseURLGST + "/customer/login";
export var apiURL = environment.apiBaseURLGST;
export var isTokenValid = environment.apiBaseURLInsight + "/login/isTokenValid";
export var maxFileSize = 10;
export var downloadExcelURL = environment.apiBaseURLGST + "/downloadExcel";
export var downloadNewExcelURL =
  environment.apiBaseURLGST + "/downloadReportNew";
export var downloadConsoleReportUrl =
  environment.apiBaseURLGST + "/generateConsoleReport";
export var apiURLAruhat = environment.apiBaseURLInsight + "/web";

//url for upload gst pdf
export var uploadGSTPdfURL =
  environment.apiBaseURLGST + "/createDigitalPdfOrder/";

//url for check pan and return period is valid or not
export var checkOrderValid = environment.apiBaseURLGST + "/isOrderExistsForPAN";
//Authentication Section
export var login_body = {
  "user-id": "",
  password: "",
  "source-system": "",
};

export var getOTP_body = {
  user_id: "",
  gstin: "",
  username: "",
  otp: "",
  "source-system": "",
  fromDate: null || "",
  toDate: null || "",
  requestId: "",
};

export var resendOTP_body = {
  user_id: "",
  gstin: "",
  username: "",
  otp: "",
  "source-system": "",
  fromDate: null || "",
  toDate: null || "",
  requestId: "",
  jobMasterId: "",
};

//GSTIN List
export var getGSTIN_LIST_body = {
  user_id: "",
  gstin: "",
  username: "",
  "source-system": "",
  searchinputtext: "",
  start: "",
  recordsize: "",
};

//Download Document
export var getDownloadDoc_body = {
  user_id: "",
  gstinid: "",
  reportId: "",
  source_system: "webapp",
  api_auth_token: "",
  client_secret_token: "",
  userId: 946,
};

// Insight Registration Body
export var registrationContent_body = {
  request: "web/get_static_page",
  para: {
    slug: "registration",
    source_system: "webapp",
  },
};

export var placeOrder_body = {
  para: {
    api_auth_token: "",
    client_secret_token: "684E4AD3D9C75EE37FEF487D18FB2",
    user_id: "",
    entity_name: " ",
    pan: " ",
    email_id: "",
    mobile_number: null,
    extration_type: " ",
    report_type: "",
    currency: "",
    email_to: "",
    email_cc: "",
    source_system: "webapp",
    corporate_id: "",
  },
};

export var allOrder_body = {
  para: {
    api_auth_token: "",
    client_secret_token: "684E4AD3D9C75EE37FEF487D18FB2",
    user_id: "",
    page_size: "",
    page_offset: "",
    query_param: "",
    source_system: "webapp",
    sort: {
      sort_by: "",
      order: "",
    },
  },
};

export var est_details_body = {
  para: {
    api_auth_token: "b*****N",
    client_secret_token: "684E4AD3D9C75EE37FEF487D18FB2",
    user_id: "",
    entity_name: "",
    pan: "",
    cin: "",
    page_size: "",
    page_offset: "",
    State: "",
    entity_id: "",
    source_system: "webapp",
    sort: {
      sort_by: "",
      order: "",
    },
  },
};

export var downloadReportBody = {
  para: {
    api_auth_token: "",
    client_secret_token: "",
    user_id: "",
    gstin: "",
    pan: "",
    currencyId: 0,
    source_system: "webapp",
  },
};
export var downloadExcelBody = {
  pan: "",
};

export var borrower_details_body = {
  workorder_type_id: 1,
  from_date: "2020-07-16",
  to_date: "2020-11-20",
  return_types: [],
  source_system_id: 1,
  source_system_remarks: "remarks here",
  corporate_id: "",
  user_id: "",
  order_id: "",
  gst_logins: [{ username: "", password: "", gstin: "" }],
};

export var borrower_details_captcha_body = {
  workorder_type_id: 3,
  from_date: "2020-07-16",
  to_date: "2020-11-20",
  return_types: [],
  source_system_id: 1,
  source_system_remarks: "remarks here",
  corporate_id: "",
  user_id: "",
  gst_logins: [{ username: "", password: "", gstin: "" }],
  order_id: "",
};

export var borrower_details_resend_OTP_body = {
  request_id: "",
  gst_logins: [{ username: "", password: "", gstin: "" }],
};

export var borrower_details_submit_OTP_body = {
  request_id: "",
  gst_logins: [{ username: "", password: "", gstin: "", otp: '' }],
  order_id: "",
};

export var borrower_capture_consent_approval_body = {
  para: {
    gstin: "",
    user_id: "",
    source_system: "webapp",
    orderId: "",
    encryptedOrderId: "",
    enableAPIAccess: false,
  },
};

export var add_mail = {
  para: {
    api_auth_token: "b*****N",
    client_secret_token: "684E4AD3D9C75EE37FEF487D18FB2",
    entity_id: "",
    //  "order_id": "",
    gstin_id: "",
    gstin: "",
    state: "",
    user_id: "",
    email_to: "",
    email_cc: "",
    consent_link: "",
    source_system: "webapp",
  },
};

export var delete_mail = {
  para: {
    api_auth_token: "b*****N",
    client_secret_token: "684E4AD3D9C75EE37FEF487D18FB2",
    gstin_id: "",
    entity_id: "",
    entity_name: " ",
    user_id: "",
    email_to: "",
    email_cc: "",
    source_system: "webapp",
  },
};

export var sendLink = {
  para: {
    api_auth_token: "b*****N",
    client_secret_token: "684E4AD3D9C75EE37FEF487D18FB2",
    user_id: "",
    entity_id: "",
    gstins_id: [],
    type: "", //copyLink sendConsentLink
    lender_name: "HDFC Bank",
    source_system: "webapp",
    lender_email: "",
  },
};

export var productInfo_body = {
  request: "getProductInfoByUser",
  para: {
    api_auth_token: "",
    user_id: "",
    source_system: "webapp",
  },
};

export var loadViewConfig_body = {
  request: "loadViewConfig",
  para: {
    api_auth_token: "",
    user_id: "",
    source_system: "webapp",
  },
};

//for upload gst pdf
export var uploadGStpdf = {
  api_auth_token: "",
  client_secret_token: "684E4AD3D9C75EE37FEF487D18FB2",
  corporate_id: "",
  user_id: "",
  pan: "",
  from_date: "",
  to_date: "",
  gstin: "",
  is_all_error_file_order: false,
  return_period: "",
  return_form: "",
  user_wo_id: "",
  source_system: "webapp",
  // "corporateId":""
};

//dto for check pan and return_perios is valid or not
export var isOrderValid = {
  pan: "",
  fromDate: "",
  toDate: "",
  corporateId: "",
};

export var fetchUserPreferances = {
  userId: "",
  preferances: "",
};

export var updateUserPreferances = {
  userId: "",
  showProductGuideVideo: "",
};

export var getStatus = {
  entityId: "",
};

export var getStatusForGst = {
  gstId: "",
};

export var loginReq = {
  username: "",
  password: "",
  orderId: "",
};

export var StatusRequestOtp = {
  orderId: "",
};

export var consoleReportBody = {
  para: {
    api_auth_token: "",
    client_secret_token: "",
    user_id: "",
    entity_id: "",
    pan: "",
    currencyId: 0,
    source_system: "webapp",
  },
};
